import React, { FC } from "react"
import { Container, Paper, Box } from "@mui/material"
import { OIDCCallback } from "../../components/auth/oidc"

interface IOIDCCallbackPageProps {}

export const OIDCCallbackPage: FC<IOIDCCallbackPageProps> = () => {
  return (
    <Container maxWidth="xs">
      <Paper elevation={3}>
        <Box p={3}>
          <OIDCCallback />
        </Box>
      </Paper>
    </Container>
  )
}
